import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { SKELETON_ANIMATION, skeletonTintSx } from './skeletonTokens';

export interface MetricCardsRowSkeletonProps {
  count?: number;
  height?: number;
  borderRadius?: number | string;
  gap?: number;
}

/**
 * Horizontal row of metric card placeholders (dashboard KPI strip).
 */
export const MetricCardsRowSkeleton: React.FC<MetricCardsRowSkeletonProps> = ({
  count = 8,
  height = 100,
  borderRadius = 1,
  gap = 1,
}) => (
  <Box
    sx={{
      display: 'flex',
      width: '100%',
      gap,
      mb: 2,
      flexWrap: { xs: 'wrap', md: 'nowrap' },
      '& > *': { flex: { xs: '1 1 45%', md: '1 1 0' }, minWidth: 0 },
    }}
    role="status"
    aria-label="Loading metrics"
  >
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton
        key={i}
        variant="rounded"
        animation={SKELETON_ANIMATION}
        height={height}
        sx={{ borderRadius, ...skeletonTintSx }}
      />
    ))}
  </Box>
);
